import React , {useEffect} from "react";
import PropTypes from 'prop-types';
import tcencoImage from 'images/home-isla-2-min.png'
import ImageLoad from 'components/ImageLoad';
import TagManagerService from 'services/TagManager';
import Link from 'components/Link';
import style from './style.scss'; //NOSONAR

const BannerCategoriesOffers = (props) => {
    const tagItem = [];
    let countItem = 1;
    const banner = props.item.banner_offer && props.item.banner_offer.length ? props.item.banner_offer[0] : null;

    if (!banner) return '';
    
    const imageMobile = banner.imagen_mobile ? banner.imagen_mobile : '';
    const imageDesktop = banner.imagen_desktop ? banner.imagen_desktop : '';

    const altDescription = imageDesktop.alt || imageMobile.alt;
    const linksBanner =  imageDesktop.url || imageMobile.url;

    const imageResponsive = {
        839: imageMobile ? imageMobile.url : '',
        1440: imageDesktop ? imageDesktop.url : ''
    };
    const fullWidth = props.item.fullWidth;


    banner.typePromotion = 'Vitrina ' + props.shelfIsland;


    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        banner.id = (banner.imagen_mobile && banner.imagen_mobile.url) ? banner.imagen_mobile.url.split('/').pop() : '';
    } else {
        banner.id = (banner.imagen_desktop && banner.imagen_desktop.url) ? banner.imagen_desktop.url.split('/').pop() : '';
    }

    let position = 'slot' + (countItem);

    tagItem.push({
        id: banner.id,
        name: banner.title ? banner.title : banner.id,
        creative: banner.typePromotion,
        position: position
    });

    useEffect(()=>{
        TagManagerService.promotionsImpressions(tagItem);
    },[]);

    const promotionClick = () =>  {
        const bannerClick = {
            id: banner.id,
            title: banner.title ? banner.title : banner.id,
            creative: 'Vitrina ' + props.shelfIsland,
            position: position
            
        };

        TagManagerService.promotionsClick(bannerClick);
    };

    return (
        <section className={"wrapper-banner-categorires-offers" + (fullWidth ? ' banner-fullwidth' : '')}>
            <Link to={linksBanner} target="_blank" className={(banner.tcenco === true) ? "banner-categories " : 'banner-categories-false'} onClick={() => promotionClick()}>
                <ImageLoad src={imageMobile ? imageMobile.url : ''} srcSet={imageResponsive} alt={altDescription} className="banner-categories-imagen"/>
            </Link>
            {banner.tcenco === true && <div className="banner-categories-tcenco">
                <span className="banner-categories-tcenco-title">Ofertas Exclusivas</span>
                <ImageLoad src={tcencoImage} className="banner-categories-tcenco-image" alt="Cencosud"/>
            </div>}
        </section>
    )
};

BannerCategoriesOffers.propTypes = {
    item: PropTypes.object,
    shelfIsland: PropTypes.number
};

export default BannerCategoriesOffers;
